import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

interface ConfirmContentProps {
  onNo: () => void;
  onYes: () => void;
}

const ConfirmContent = ({ onNo, onYes }: ConfirmContentProps) => {
  const navigate = useNavigate();

  const handleNo = () => {
    navigate("/faqs");
    onNo();
  };

  const handleYes = () => {
    onYes();
  };

  return (
    <>
      <DialogContent>
        <DialogContentText color="textPrimary">
          Before submitting a question, have you researched through our
        </DialogContentText>

        <Link to="/faqs" onClick={handleNo}>
          FAQs and Knowledge Center?
        </Link>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="error" onClick={handleNo}>
          No, take me to FAQs
        </Button>
        <Button variant="contained" color="success" onClick={handleYes}>
          Yes
        </Button>
      </DialogActions>
    </>
  );
};

export default ConfirmContent;
